var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 16.3298H14M9.0177 2.09383L2.23539 7.36896C1.78202 7.72158 1.55534 7.89789 1.39203 8.11869C1.24737 8.31428 1.1396 8.53462 1.07403 8.76889C1 9.03335 1 9.32053 1 9.89489V17.1298C1 18.2499 1 18.81 1.21799 19.2378C1.40973 19.6141 1.71569 19.9201 2.09202 20.1118C2.51984 20.3298 3.07989 20.3298 4.2 20.3298H15.8C16.9201 20.3298 17.4802 20.3298 17.908 20.1118C18.2843 19.9201 18.5903 19.6141 18.782 19.2378C19 18.81 19 18.2499 19 17.1298V9.89489C19 9.32053 19 9.03335 18.926 8.76889C18.8604 8.53462 18.7526 8.31428 18.608 8.11869C18.4447 7.89789 18.218 7.72158 17.7646 7.36896L10.9823 2.09383C10.631 1.82058 10.4553 1.68395 10.2613 1.63143C10.0902 1.58509 9.9098 1.58509 9.73865 1.63143C9.54468 1.68395 9.36902 1.82058 9.0177 2.09383Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/homeIcon.bce0baffac6b72d4b3a9efa56dd97ef9.svg";
export { ForwardRef as ReactComponent };